import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAddressCard, faArrowRight, faArrowRightFromBracket, faArrowRightToBracket,
    faArrowsLeftRight, faArrowUpFromBracket,
    faBars,
    faBell, faBriefcase, faBuilding, faBuildings,
    faBuildingUser,
    faBusinessTime, faCalendar, faCalendarArrowDown,
    faCalendarCircleUser, faCalendarDays,
    faCalendarMinus,
    faCalendarPlus, faCalendarXmark,
    faChartLine,
    faChartSimple, faCheckToSlot, faChevronLeft, faChevronRight, faCircleCheck, faCircleUserCircleCheck, faCircleXmark,
    faClock, faClockRotateLeft, faCloudUploadAlt, faCodeBranch,
    faColumns3, faDot, faDownload, faEarthEurope, faEdit,
    faEnvelope, faEnvelopeOpenText,
    faFileChartPie, faFileCirclePlus,
    faFileContract, faFileExport,
    faFileInvoiceDollar, faFileLines,
    faFilter,
    faFilterList,
    faGears, faGrid, faGripDots, faGripDotsVertical,
    faHandHoldingCircleDollar, faHashtag, faHourglassEnd, faHourglassStart,
    faIdBadge, faInboxIn, faLink, faLocationDot,
    faLock,
    faMagnifyingGlass,
    faMoneyBillsSimple, faPeopleGroup, faPlay, faPlus,
    faProjectDiagram, faSlashForward,
    faSquareList, faStop, faStopwatch, faSyncAlt, faTableList,
    faTimer,
    faToggleOn, faUndo, faUser, faUserGear, faUserMinus, faUserQuestion,
    faUserTag, faUserTie, faVenusMars,
    faXmark, faXmarkToSlot
} from "@fortawesome/pro-regular-svg-icons";
import clsx from "clsx";
import React from "react";


interface IconProps {
    className?: string;
}

// App bar
export const IconAppBarNotifications = () => <FontAwesomeIcon icon={faBell} className={'icon-primary'} />;

// Drawer icons
export const IconMainDrawerCloseDrawer = () => <FontAwesomeIcon icon={faChevronLeft} className={'icon-primary'} />;
export const IconMainDrawerOpenDrawer = () => <FontAwesomeIcon icon={faBars} className={'icon-primary'} />;

// Navigation menu icons
export const IconMainNavigationDashboard = () => <FontAwesomeIcon icon={faGrid} className={'icon-primary'} />;
export const IconMainNavigationAbsences = () => <FontAwesomeIcon icon={faCalendarXmark} className={'icon-primary'} />;
export const IconMainNavigationEmployees = () => <FontAwesomeIcon icon={faBuildingUser} className={'icon-primary'} />;
export const IconMainNavigationTimetracking = () => <FontAwesomeIcon icon={faBusinessTime} className={'icon-primary'} />;
export const IconMainNavigationAbsenceCalendar = () => <FontAwesomeIcon icon={faCalendarCircleUser} className={'icon-primary'} />;
export const IconMainNavigationReporting = () => <FontAwesomeIcon icon={faFileChartPie} className={'icon-primary'} />;
export const IconMainNavigationPayrolls = () => <FontAwesomeIcon icon={faMoneyBillsSimple} className={'icon-primary'} />;
export const IconMainNavigationDocumentTemplates = () => <FontAwesomeIcon icon={faFileLines} className={'icon-primary'} />;
export const IconMainNavigationAutomations = () => <FontAwesomeIcon icon={faUserGear} className={'icon-primary'} />;
export const IconMainNavigationSettings = () => <FontAwesomeIcon icon={faGears} className={'icon-primary'} />;

export const IconDeleteInRow = () => <FontAwesomeIcon icon={faXmark} className={'icon-primary'} />;
export const IconFilterButton = () => <FontAwesomeIcon icon={faFilter} className={'icon-primary'} />;


// Extentions
export const IconMainNavigationPayoffs = () => <FontAwesomeIcon icon={faHandHoldingCircleDollar} className={'icon-primary'} />;
export const IconMainNavigationPayoffsTransactions = () => <FontAwesomeIcon icon={faArrowsLeftRight} className={'icon-primary'} />;
export const IconMainNavigationPayoffsPayoffs = () => <FontAwesomeIcon icon={faFileInvoiceDollar} className={'icon-primary'} />;

export const IconMainNavigationPerformance = () => <FontAwesomeIcon icon={faChartSimple} className={'icon-primary'} />;

export const IconMainNavigationSales = () => <FontAwesomeIcon icon={faChartLine} className={'icon-primary'} />;
export const IconMainNavigationSalesOverview = () => <FontAwesomeIcon icon={faSquareList} className={'icon-primary'} />;
export const IconMainNavigationSalesMySales = () => <FontAwesomeIcon icon={faUserTag} className={'icon-primary'} />;

// Reauth modal
export const IconReauthModalSessionExpired = () => <FontAwesomeIcon icon={faLock} className={'icon-primary'} />;

// Employees table
export const IconEmployeeTableFilters: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faFilterList} className={clsx('icon-primary', className)} />
);

export const InputSetToNull: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faXmark} className={clsx('icon-primary', className)} />
);

export const IconEmployeeTableConfigureColumns: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faColumns3} className={clsx('icon-primary', className)} />
);

export const DragIndicatorIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faGripDots} className={clsx('icon-primary', className)} />
);

export const DragIndicatorVerticalIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faGripDotsVertical} className={clsx('icon-primary', className)} />
);

// Search field
export const IconSearchField: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faMagnifyingGlass} className={clsx('icon-primary', className)} />
);

// Settings
export const IconSettingsCategoryOrganization: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faBuildings} className={clsx('icon-primary', className)} />
);

export const IconSettingsCategoryEmployees: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faBuildingUser} className={clsx('icon-primary', className)} />
);

export const IconSettingsCategoryWorktime: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faBusinessTime} className={clsx('icon-primary', className)} />
);

export const IconSettingsCategorySubscription: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faSyncAlt} className={clsx('icon-primary', className)} />
);

export const IconSettingsCategoryOrganizationBranches: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faEarthEurope} className={clsx('icon-primary', className)} />
);

export const IconSettingsCategoryOrganizationDepartments: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faPeopleGroup} className={clsx('icon-primary', className)} />
);



// Icon library
export const AddressCardIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faAddressCard} className={clsx('icon-primary', className)} />
);

export const ProjectDiagramIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faProjectDiagram} className={clsx('icon-primary', className)} />
);

export const EnvelopeIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faEnvelope} className={clsx('icon-primary', className)} />
);

export const ClockIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faClock} className={clsx('icon-primary', className)} />
);

export const FileContractIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faFileContract} className={clsx('icon-primary', className)} />
);

export const CalendarPlusIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faCalendarPlus} className={clsx('icon-primary', className)} />
);

export const CalendarMinusIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faCalendarMinus} className={clsx('icon-primary', className)} />
);

export const IdBadgeIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faIdBadge} className={clsx('icon-primary', className)} />
);

export const CodeBranchIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faCodeBranch} className={clsx('icon-primary', className)} />
);

export const BuildingIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faBuilding} className={clsx('icon-primary', className)} />
);

export const PeopleGroupIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faPeopleGroup} className={clsx('icon-primary', className)} />
);

export const HourglassStartIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faHourglassStart} className={clsx('icon-primary', className)} />
);

export const HourglassEndIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faHourglassEnd} className={clsx('icon-primary', className)} />
);

export const VenusMarsIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faVenusMars} className={clsx('icon-primary', className)} />
);

export const HashtagIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faHashtag} className={clsx('icon-primary', className)} />
);

export const UserTagIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faUserTag} className={clsx('icon-primary', className)} />
);

export const UserIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faUser} className={clsx('icon-primary', className)} />
);

export const BriefcaseIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faBriefcase} className={clsx('icon-primary', className)} />
);

export const BusinessTimeIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faBusinessTime} className={clsx('icon-primary', className)} />
);

export const UserTieIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faUserTie} className={clsx('icon-primary', className)} />
);

export const ToggleOnIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faToggleOn} className={clsx('icon-primary', className)} />
);

export const LocationDotIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faLocationDot} className={clsx('icon-primary', className)} />
);

export const InboxInIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faInboxIn} className={clsx('icon-primary', className)} />
);

export const CalendarDaysIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faCalendarDays} className={clsx('icon-primary', className)} />
);

export const UndoIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faUndo} className={clsx('icon-primary', className)} />
);

export const ApproveIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faCheckToSlot} className={clsx('icon-primary', className)} />
);

export const RejectIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faXmarkToSlot} className={clsx('icon-primary', className)} />
);

export const EscalateIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faArrowUpFromBracket} className={clsx('icon-primary', className)} />
);

export const ClarifyIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faUserQuestion} className={clsx('icon-primary', className)} />
);

export const TerminateEmployeeIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faUserMinus} className={clsx('icon-primary', className)} />
);

export const AbsenceCalendarIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faCalendarXmark} className={clsx('icon-primary', className)} />
);

export const PlusIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faPlus} className={clsx('icon-primary', className)} />
);

export const CloseIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faXmark} className={clsx('icon-primary', className)} />
);

export const DeleteIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faXmark} className={clsx('icon-primary', className)} />
);

export const SaveIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faXmark} className={clsx('icon-primary', className)} />
);

export const EditIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faEdit} className={clsx('icon-primary', className)} />
);

export const DownloadIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faDownload} className={clsx('icon-primary', className)} />
);

export const FileExportIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faFileExport} className={clsx('icon-primary', className)} />
);

export const TableIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faTableList} className={clsx('icon-primary', className)} />
);

export const CalendarArrowDownIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faCalendarArrowDown} className={clsx('icon-primary', className)} />
);

export const CloudUploadAltIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faCloudUploadAlt} className={clsx('icon-primary', className)} />
);

export const EmployeeStatusIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faCircleUserCircleCheck} className={clsx('icon-primary', className)} />
);

export const ResentAccountSetupLinkIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faLink} className={clsx('icon-primary', className)} />
);

export const PreviousMonthIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faChevronLeft} className={clsx('icon-primary', className)} />
);

export const NextMonthIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faChevronRight} className={clsx('icon-primary', className)} />
);

export const CalendarIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faCalendar} className={clsx('icon-primary', className)} />
);

export const InstantiateTemplateIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faFileCirclePlus} className={clsx('icon-primary', className)} />
);

export const SalutationIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faEnvelopeOpenText} className={clsx('icon-primary', className)} />
);

export const ClockInIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faArrowRightToBracket} className={clsx('icon-primary', className)} />
);

export const ClockOutIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faArrowRightFromBracket} className={clsx('icon-primary', className)} />
);

export const StopwatchIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faStopwatch} className={clsx('icon-primary', className)} />
);

export const TimerIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faTimer} className={clsx('icon-primary', className)} />
);

export const PlayIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faPlay} className={clsx('icon-primary', className)} />
);

export const StopIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faStop} className={clsx('icon-primary', className)} />
);

export const ClockHistoryIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faClockRotateLeft} className={clsx('icon-primary', className)} />
);

export const CircleCheckIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faCircleCheck} className={clsx('icon-primary', className)} />
);

export const CircleXmarkIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faCircleXmark} className={clsx('icon-primary', className)} />
);

export const SlashForwardIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faSlashForward} className={clsx('icon-primary', className)} />
);

export const ArrowRightIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faArrowRight} className={clsx('icon-primary', className)} />
);

export const DotIcon: React.FC<IconProps> = ({ className }) => (
    <FontAwesomeIcon icon={faDot} className={clsx('icon-primary', className)} />
);

export const iconMap: Record<string, React.ReactNode> = {
    addressCard: <AddressCardIcon />,
    idBadge: <IdBadgeIcon />,
    projectDiagram: <ProjectDiagramIcon />,
    envelope: <EnvelopeIcon />,
    clock: <ClockIcon />,
    fileContract: <FileContractIcon />,
    calendarPlus: <CalendarPlusIcon />,
    calendarMinus: <CalendarMinusIcon />,
    codeBranch: <CodeBranchIcon />,
    buildingIcon: <BuildingIcon />,
    peopleGroup: <PeopleGroupIcon />,
    hourglassStart: <HourglassStartIcon />,
    hourglassEnd: <HourglassEndIcon />,
    venusMars: <VenusMarsIcon />,
    hashtag: <HashtagIcon />,
    userTagIcon: <UserTagIcon />,
    user: <UserIcon />,
    briefcase: <BriefcaseIcon />,
    businessTime: <BusinessTimeIcon />,
    userTie: <UserTieIcon />,
    toggleOn: <ToggleOnIcon />,
    inboxIn: <InboxInIcon />,
    calendarDays: <CalendarDaysIcon />,
    undo: <UndoIcon />,
    approve: <ApproveIcon />,
    reject: <RejectIcon />,
    escalate: <EscalateIcon />,
    clarify: <ClarifyIcon />,
    terminateEmployee: <TerminateEmployeeIcon />,
    absenceCalendar: <AbsenceCalendarIcon />,
    plus: <PlusIcon />,
    employeeStatus: <EmployeeStatusIcon />,
    download: <DownloadIcon />,
    delete: <DeleteIcon />,
    salutation: <SalutationIcon />,
    clockIn: <ClockInIcon />,
    clockOut: <ClockOutIcon />,
    stopwatch: <StopwatchIcon />,
    timer: <TimerIcon />,
    clockHistory: <ClockHistoryIcon />
};